function RomanianFlag({
  width = '60',
  height = '50',
  className,
}: {
  width?: string;
  height?: string;
  className?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      viewBox="0 0 200 146"
    >
      {/* Blue stripe */}
      <path d="M0 0.777832H66.6667V145.222H0V0.777832Z" fill="#002B7F" />
      {/* Yellow stripe */}
      <path d="M66.6667 0.777832H133.333V145.222H66.6667V0.777832Z" fill="#FCD116" />
      {/* Red stripe */}
      <path d="M133.333 0.777832H200V145.222H133.333V0.777832Z" fill="#CE1126" />
    </svg>
  );
}

export { RomanianFlag };
